<template>
  <div
    v-if="development && plots"
    class="vh-100 w100 relative overflow-hidden"
  >
    <SitePlan
      :development="development"
      :plots="plots"
      @select="selectPlot"
      ref="sitePlan"
    />
    <SitePlanCard
      v-for="(plot, index) in plots"
      :key="index"
      :ref="'card-' + index"
      :active="active"
      :content="plot"
      :style="getStyle(plot.houseTypeId)"
      @select="selectPlot"
    />
    <Filters :plots="plots" />
    <Legend :property-styles="development.styles" />
    <div
      class="absolute right-0 top-0 bottom-0 ma4 flex flex-column justify-center"
      style="pointer-events: none"
    >
      <div class="ba br2 b--moon-gray">
        <div
          class="gray bg-near-white ph3 pv2 f2 lh-solid bb b--moon-gray"
          style="pointer-events: auto"
          @click="zoom('in')"
        >
          &plus;
        </div>
        <div
          class="gray bg-near-white ph3 pv2 f2 lh-solid"
          style="pointer-events: auto"
          @click="zoom('out')"
        >
          &minus;
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Filters from '@/components/siteplan/Filters'
import SitePlanCard from '@/components/siteplan/SitePlanCard'
import Legend from '@/components/siteplan/Legend'
import SitePlan from '@/components/siteplan/SitePlan'
// import VueDraggableResizable from 'vue-draggable-resizable'

const find = require('lodash/find')

export default {
  name: 'Development',
  components: {
    SitePlanCard,
    Filters,
    Legend,
    SitePlan
    // VueDraggableResizable
  },
  data () {
    return {
      active: null
    }
  },
  computed: {
    development () {
      if (this.$store.state.content) {
        return this.$store.getters.getDevelopment(this.$route.path.substr(1))
      } else {
        return null
      }
    },
    plots () {
      if (this.$store.state.content) {
        return this.$store.getters.getPlots(this.development.crm)
      } else {
        return null
      }
    },
    filters () {
      return {
        availability: null,
        bedrooms: null,
        purchaseType: null,
        price: null,
        style: null,
        type: null
      }
    },
    windowHeight () {
      return window.innerHeight
    },
    windowWidth () {
      return window.innerWidth
    }
    // filters () {
    //   return this.$store.state.active.filters
    // }
  },
  methods: {
    getStyle (id) {
      const target = find(this.development.styles, ['crm', id])
      return target
    },
    selectPlot (plot) {
      this.active = Number(plot)
    },
    zoom (direction) {
      this.$refs.sitePlan.zoom(direction)
    }
  }
}
</script>
<style lang="scss" scoped>
.vdr.dragging {
  z-index: 3 !important;
}
.flip-in-hor-bottom {
  animation: flip-in-hor-bottom 0.5s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
  animation-delay: 1s;
}
@keyframes flip-in-hor-bottom {
  0% {
    transform: rotateX(80deg);
    opacity: 0;
  }
  100% {
    transform: rotateX(0);
    opacity: 1;
  }
}

.fade-in {
  animation: fade-in 1s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.slide-in-fwd-center {
  animation: slide-in-fwd-center 0.4s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}
@keyframes slide-in-fwd-center {
  0% {
    transform: translateZ(-1400px);
    opacity: 0;
  }
  100% {
    transform: translateZ(0);
    opacity: 1;
  }
}

.slide-out-bck-center {
  animation: slide-out-bck-center 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
}
@keyframes slide-out-bck-center {
  0% {
    transform: translateZ(0);
    opacity: 1;
  }
  100% {
    transform: translateZ(-1100px);
    opacity: 0;
  }
}

</style>
